import React from "react";

interface WhyChooseUsItem {
  title: string;
  content: string;
}

interface ServiceWhyChooseUsProps {
  title?: string;
  items: WhyChooseUsItem[];
}

const ServiceWhyChooseUs: React.FC<ServiceWhyChooseUsProps> = ({
  title = "Why Choose Our Services",
  items,
}) => {
  return (
    <section className="service pos-rel bg_img mt-40 mb-40">
      <h2 className="details-content-title text-center mb-50" style={{ color: "#fff" }}>{title}</h2>

      <div className="container">
        <div className="row mt-none-30">
          {items.map((item, index) => (
            <div className="col-lg-6 mt-30 wow fadeInUp" data-wow-delay={`${index * 100}ms`} key={index}>
              <div
                style={{
                  minHeight: "240px",
                  padding: "32px 30px",
                  borderRadius: "16px",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  backdropFilter: "blur(10px)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  transform: "translateY(0) scale(1)",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
                  e.currentTarget.style.boxShadow = "0 20px 40px rgba(255,140,0,0.2)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.08)";
                  e.currentTarget.style.borderColor = "rgba(255,140,0,0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.background = "rgba(255,255,255,0.06)";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.12)";
                }}
              >
                <h3
                  style={{
                    fontSize: "22px",
                    fontWeight: 600,
                    color: "#fff",
                    marginBottom: "16px",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#ff8c00";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#fff";
                  }}
                >
                  {item.title}
                </h3>
                <p style={{
                  fontSize: "15px",
                  color: "rgba(255,255,255,0.85)",
                  lineHeight: "1.7",
                  margin: 0,
                }}>
                  {item.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceWhyChooseUs;
